import React from 'react';
import { Maximize2, Music } from 'lucide-react';

/**
 * Album-art card for a generated SONG (audio) in the chat stream: the cover image on TOP, the audio
 * player BELOW. The message's action icons (download / share / regenerate / …) render underneath it
 * in the bubble. Presentational — the caller resolves the storage URLs. Falls back to a music glyph
 * when there's no cover yet, so the layout stays stable.
 */
const MediaArtCard: React.FC<{
  mediaUrl: string;
  posterUrl?: string | null;
  name: string;
  onExpand?: () => void;
}> = ({ mediaUrl, posterUrl, name, onExpand }) => (
  <div className="inline-flex w-72 max-w-full flex-col gap-2.5 rounded-xl border border-secondary-200 dark:border-secondary-700 bg-secondary-50 dark:bg-secondary-800/40 p-2.5">
    <div className="relative">
      {posterUrl ? (
        <img src={posterUrl} alt={name} className="aspect-square w-full rounded-lg object-cover" />
      ) : (
        <div className="flex aspect-square w-full items-center justify-center rounded-lg bg-secondary-100 dark:bg-secondary-700/50">
          <Music className="h-10 w-10 text-secondary-300 dark:text-secondary-500" />
        </div>
      )}
      {onExpand && (
        <button type="button" onClick={onExpand} aria-label="Expand" title="Expand"
          className="absolute right-1.5 top-1.5 rounded-md bg-black/45 p-1 text-white/85 hover:bg-black/65 hover:text-white">
          <Maximize2 className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
    <audio controls src={mediaUrl} className="w-full" data-testid="att-audio" />
  </div>
);

export default MediaArtCard;
